import { SnapshotOut, types } from "mobx-state-tree"

export const FlyingCarpetPage = types.enumeration("FlyingCarpetPage", [
  "signin",
  "account",
  "forgotpassword",
  "signup",
  "cart",
  "other",
])
export type FlyingCarpetPage = SnapshotOut<typeof FlyingCarpetPage>

const FlyingCarpet = types
  .model("FlyingCarpet", {
    currentPage: types.maybeNull(FlyingCarpetPage),
  })
  .views((self) => ({
    get isOpen() {
      return self.currentPage !== null
    },
  }))
  .actions((self) => ({
    open(page: FlyingCarpetPage) {
      self.currentPage = page
    },
    close() {
      self.currentPage = null
    },
  }))

export const flyingCarpetStore = FlyingCarpet.create({
  currentPage: null,
})
